module.exports = __webpack_public_path__ + "static/media/headLogo.b7c8a8c3.png";